import { render, staticRenderFns } from "./LoginCleaner.vue?vue&type=template&id=56c28d20"
import script from "./LoginCleaner.vue?vue&type=script&lang=js"
export * from "./LoginCleaner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports